import {
  setComponent,
  componentMethods,
  getVeriCode,
  veriCodeLoginFn,
  mobileOrEmailLoginFn,
  wxLogin,
  qqLogin,
  weiboLogin,
  countdownFn
} from 'src/frontend-lib/component/login/index'
import { GetRequest } from 'src/public-resource/libs/utils/index'
import 'src/frontend-lib/component/login/index.scss'
import './style.scss'
import { axios as $http } from 'cm'
import qs from 'qs'
import { loadScript } from 'src/frontend-lib/tools/loadScript.js'
let isPhone = window.$platform.isMobile
let isCeShiApp = window.$platform.isCeShiApp
const userAgent = navigator.userAgent
let isInMini =
  /miniProgram/i.test(userAgent) || /toutiaomicroapp/i.test(userAgent)

function init() {
  let chinaPhoneReg = new RegExp(/^1\d{10}$/)
  let overseaPhoneReg = new RegExp(/^[0-9]+$/)
  let getPhoneReg = areaCode =>
    areaCode == 86 ? chinaPhoneReg : overseaPhoneReg

  let loadUniScripts = () =>
    Promise.all(
      [
        `https://res.wx.qq.com/open/js/jweixin-1.6.0.js`,
        `https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js`
      ].map(v => loadScript(v))
    )

  // 进入智能校验
  // let today = new Date()
  // const timeStamp = `${today.getFullYear()}${today.getMonth() +
  //   1}${today.getDay()}`
  // loadScript(`${`//g.alicdn.com/AWSC/AWSC/awsc.js`}?t=${timeStamp}`).then(
  //   () => {
  //     let el = `<div class="captcha-popup"><div class="captcha-title">请完成下方验证后继续</div><div class="captcha-content" id="captcha"></div></div>`
  //     document.querySelector('#popup-captcha').innerHTML = el
  //   }
  // )

  let successHandler = () => {
    if (GetRequest().isWebviewMp) {
      // 咨询小程序内刷新
      loadUniScripts().then(() => {
        window.uni.postMessage({
          data: {
            type: 'refresh'
          }
        })

        setTimeout(() => {
          window.uni.navigateBack({
            delta: 1
          })
        }, 1000)
      })
      return true
    }

    return false
  }

  // 加载登录表单
  if (document.getElementById('login')) {
    // 页面设置
    console.log(
      66666,
      document.getElementById('login'),
      document.getElementById('login').innerHTML
    )
    document.getElementById('login').innerHTML = setComponent({
      // 如果是口袋心理测试APP，则隐藏第三方登录
      hiddenThirdLogin:
        isCeShiApp || isInMini ? true : GetRequest().hiddenThirdLogin,
      hiddenOtherLogin: GetRequest().hiddenOtherLogin
    })
    // 加载交互方法
    componentMethods()
    let _token = ''
    // 获取页面token
    if (document.getElementsByName('_token')) {
      _token = document.getElementsByName('_token')[0].value || ''
    }
    // 获取验证码
    getVeriCode(function(mobile, areaCode) {
      // 清空智能校验
      $('#captcha').empty()

      let phoneReg = getPhoneReg(areaCode)
      if (mobile === '') {
        window.toast('手机号不能为空', 3000)
        return false
      }
      if (!phoneReg.test(mobile)) {
        window.toast('手机号格式有误', 3000)
        return
      }

      // 设置全局的消息类型
      // let msg_type = 'sms'
      // let nc_appkey = 'FFFF0N0N000000007312'
      // let nc_token = [nc_appkey, new Date().getTime(), Math.random()].join(':')
      // AWSC.use('ic', (state, module) => {
      //   // 初始化
      //   window.ic = module.init({
      //     appkey: nc_appkey || 'FFFF0N0N000000007312',
      //     scene: 'ic_message_h5',
      //     renderTo: 'captcha',
      //     token: nc_token,
      //     success: data => {
      //       let params = {
      //         account: mobile,
      //         nc_sessionid: data.sessionId,
      //         nc_token: nc_token,
      //         nc_sig: data.sig,
      //         nc_scene: data.scene,
      //         appkey: nc_appkey,
      //         type: msg_type
      //       }
      //       if (areaCode !== '86') {
      //         params.is_oversea = 1
      //         params.account = areaCode + '' + mobile
      //       }
      //       $http
      //         .post(
      //           window.baseInfo.checkValidateAliyunUrl,
      //           qs.stringify(params)
      //         )
      //         .then(function(resp) {
      //           window.toast(resp.data.message, 3000)
      //           if (resp.data.code == null || resp.data.code == 0) {
      //             // 倒计时
      //             countdownFn()
      //             // 初始化智能校验状态
      //             setTimeout(() => {
      //               window.ic.reset()
      //               document.getElementById('popup-captcha').style.display =
      //                 'none'
      //             }, 1000)
      //           }
      //         })
      //     },
      //     fail: () => {
      //       window.ic.reset()
      //     },
      //     error: () => {
      //       window.ic.reset()
      //     }
      //   })
      // })

      var captcha
      // 弹出式，除region和prefix以外的参数
      window.initAliyunCaptcha({
        // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
        SceneId: 'igx61m86',
        // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
        mode: 'popup',
        // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
        element: '#popup-captcha',
        // 触发验证码弹窗或无痕验证的元素
        // button: "#validi .js-sendPhoneCode",
        // 验证码验证通过回调函数
        success: function(captchaVerifyParam) {
          const params = {
            callback: '',
            account: mobile,
            module: '',
            is_oversea: 0,
            oversea_pass: '',
            captchaVerifyParam
          }
          if (areaCode !== '86') {
            params.is_oversea = 1
            params.account = areaCode + '' + mobile
          }
          $http
            .post(
              window.baseInfo.checkValidateV2AliyunUrl,
              qs.stringify(params)
            )
            .then(function(resp) {
              window.toast(resp.data.message, 3000)
              if (resp.data.code == null || resp.data.code == 0) {
                // 倒计时
                countdownFn()
                // 初始化智能校验状态
                // setTimeout(() => {
                //   window.ic.reset()
                //   document.getElementById('popup-captcha').style.display =
                //     'none'
                // }, 1000)
              }
            })
          // 入参为验签captchaVerifyParam
          // 1.向后端发起业务请求进行验证码验签captchaVerifyParam校验
          // 2.根据校验结果来进行业务处理
          // 3.如业务需要重新进行验证码验证，调用验证码初始化方法initAliyunCaptcha重新初始化验证码
        },
        // 验证码验证不通过回调函数
        fail: function(result) {
          // initCaptcha()
          // 入参为不通过信息
          // 正常验证有效期内不需要做任何操作，验证码自动刷新，重新进行验证
          console.error(result)
        },
        // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
        getInstance: function(instance) {
          captcha = instance
          captcha.show()
          document.querySelector('#aliyunCaptcha-title').style.fontSize = '14px'
          document.querySelector('#aliyunCaptcha-certifyId').style.display =
            'none'
        },
        // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。
        slideStyle: {
          width: 320,
          height: 40
        },
        upLang: {
          cn: {
            POPUP_TITLE: '请先完成安全验证，即可获取短信验证码'
          }
        },
        onClose: function() {
          $('#send_validcode').data('lock', false)
        },
        onError: function(error) {
          console.error(error)
        }
        // ...其他参数，参考initAliyunCaptcha参数说明
      })
      // document.getElementById('popup-captcha').style.display = 'block'
      // document.getElementById('popup-captcha').style.marginTop = '10px'
    })
    // 手机验证码登陆登录
    veriCodeLoginFn(function(mobile, veriCode, areaCode) {
      let phoneReg = getPhoneReg(areaCode)
      if (mobile === '') {
        window.toast('手机号不能为空', 3000)
        return
      }
      // 86 时才验证手机
      if (!phoneReg.test(mobile)) {
        window.toast('手机号格式有误', 3000)
        return
      }
      if (veriCode === '') {
        window.toast('验证码不能为空', 3000)
        return
      }

      let params = {
        phone: mobile,
        validcode: veriCode,
        agree: 'on',
        _token: _token,
        lai_yuan: isPhone ? 'mobile' : 'PC'
      }
      let ajaxUrl = window.baseInfo.mobileLoginUrl
      if (areaCode !== '86') {
        ajaxUrl = window.baseInfo.overseaPostUrl
        params = {
          _token: _token,
          area: areaCode,
          phone: mobile,
          validcode: veriCode,
          agree: 1
        }
      } else {
      }
      $http
        .post(ajaxUrl, qs.stringify(params), {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then(({ data }) => {
          if (data.code === 0) {
            window.toast(data.message || '登录成功', 3000)
            let isFunHandlerd
            try {
              isFunHandlerd = successHandler()
            } catch (e) {
              console.log(e)
            }
            if (!isFunHandlerd) {
              window.location.href = data.next
            }
          } else {
            window.toast(data.message || '登录失败', 3000)
          }
        })
    })
    // 手机或邮箱号登录
    mobileOrEmailLoginFn(function(account, password) {
      let phonereg = new RegExp(/^1\d{10}$/)

      if (account === '') {
        window.toast('用户名不能为空', 3000)
        return
      } else if (
        !(
          account.match(phonereg) ||
          account.match(
            /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/
          )
        )
      ) {
        window.toast('账号格式有误', 3000)
        return
      }
      if (password.length === '') {
        window.toast('密码不能为空', 3000)
        return
      }
      $http
        .post(
          window.baseInfo.mobileLoginUrl,
          qs.stringify({
            username: account,
            password: password,
            _token: _token,
            lai_yuan: isPhone ? 'mobile' : 'PC'
          }),
          {
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          }
        )
        .then(({ data }) => {
          if (data.code === 0) {
            window.toast(data.message || '登录成功', 3000)
            let isFunHandlerd
            try {
              isFunHandlerd = successHandler()
            } catch (e) {
              console.log(e)
            }
            if (!isFunHandlerd) {
              window.location.href = data.next
            }
          } else {
            window.toast(data.message || '登录失败', 3000)
          }
        })
    })
    // 第三方登录
    wxLogin(function() {
      window.location.href = window.baseInfo.wechatUrl
    })
    qqLogin(function() {
      window.location.href = window.baseInfo.qqUrl
    })
    weiboLogin(function() {
      window.location.href = window.baseInfo.weiboUrl
    })
  }
}

init()



// WEBPACK FOOTER //
// ./src/pages/global/newLogin/index.js